import { AuthCache } from './types'
import { FC, ReactNode, createContext } from 'react'
import { useNewAuthCache } from './hooks'

export const AuthCacheContext = createContext<AuthCache | null>(null)

export const AuthCacheProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <AuthCacheContext.Provider value={useNewAuthCache()}>{children}</AuthCacheContext.Provider>
)
